<ng-container *ngIf="!disabled; else readonlyChip">
  <div motifDropdown class="accessIconContainer" [open]="false">
    <motif-chip
      motifDropdownToggle
      [class.accessChip]="!isRole"
      [class.roleChip]="isRole"
      [ngStyle]="{ '--chip-hover--bg-color': getChipHoverColor() }"
      [removeable]="false"
      [variant]="getVariant()"
      [type]="'chip'"
      [dotSide]="'none'"
    >
      <div class="accessTypeContainer">
        <span
          [title]="selectedvalue.name | translate"
          [ngClass]="{ accessTypeLabel: isRole, projectLabel: !isRole }"
        >
          {{ selectedvalue.name | translate }}</span
        >
        <motif-icon
          size="20"
          [iconFunction]="arrowDownIcon"
          class="motifChipIcon"
        ></motif-icon>
      </div>
    </motif-chip>
    <div
      [class.listDiv]="!isRole"
      [class.roleListDiv]="isRole"
      motifDropdownMenu
      id="motifExampleDropdownMenu"
      aria-labelledby="motifExampleDropdown"
    >
      @for (item of list; track item) {
        <button
          motifDropdownItem
          class="accessTypeChip"
          [ngClass]="{ 'selected-status': selectedvalue === item }"
          motifButton
          (click)="selectEvent(item)"
        >
          <span
            class="projectLabel"
            motif-tooltip="{{ item.name }}"
            [hideIconClose]="true"
            placement="auto"
          >
            {{ item.name | translate }}
          </span>
        </button>
      }
    </div>
  </div>
</ng-container>
<ng-template #readonlyChip>
  <div class="accessIconContainer">
    <motif-chip
      [class.accessChip]="!isRole"
      [class.roleChip]="isRole"
      [removeable]="false"
      [variant]="getVariant()"
      [type]="'chip'"
      [dotSide]="'none'"
    >
      <div class="accessTypeContainer">
        <span
          [title]="selectedvalue.name | translate"
          [ngClass]="{ accessTypeLabel: isRole, projectLabel: !isRole }"
        >
          {{ selectedvalue.name | translate }}</span
        >
      </div>
    </motif-chip>
  </div>
</ng-template>
